import {
  Directive,
  ElementRef,
  Renderer2,
  DoCheck,
  Optional,
  Self
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[pInvalidOnError]',
  standalone:true,
})
export class PInvalidOnErrorDirective implements DoCheck {
  private previousClassState = false;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    @Self() @Optional() private controlDir: NgControl
  ) {}

  ngDoCheck(): void {
    const control = this.controlDir?.control;
    if (!control || !this.el.nativeElement) return;

    const isInvalid = control.invalid && (control.touched || control.dirty);
    if (isInvalid !== this.previousClassState) {
      this.previousClassState = isInvalid;
      if (isInvalid) {
        this.renderer.addClass(this.el.nativeElement, 'p-invalid');
      } else {
        this.renderer.removeClass(this.el.nativeElement, 'p-invalid');
      }
    }
  }
}
